import { useCallback, useEffect, useState } from "react";
import useEmblaCarousel from "embla-carousel-react";
import { ChevronLeft, ChevronRight, Star } from "lucide-react";

export default function TestimonialSlider({ testimonials }) {
  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true, align: "center" });
  const [index, setIndex] = useState(0);

  const onSelect = useCallback(() => {
    if (emblaApi) setIndex(emblaApi.selectedScrollSnap());
  }, [emblaApi]);

  useEffect(() => {
    if (!emblaApi) return;
    emblaApi.on("select", onSelect);
    const t = setInterval(() => emblaApi.scrollNext(), 6000);
    return () => clearInterval(t);
  }, [emblaApi, onSelect]);

  return (
    <div data-testid="testimonial-slider" className="relative">
      <div className="overflow-hidden" ref={emblaRef}>
        <div className="flex">
          {testimonials.map((t, i) => (
            <div key={t.id || `${t.name}-${t.role}`} className="min-w-0 shrink-0 grow-0 basis-full sm:basis-1/2 lg:basis-1/3 px-4">
              <figure className="h-full rounded-2xl border border-nero/10 bg-panna-dark/40 p-8 flex flex-col">
                <div className="flex gap-1 mb-5" aria-label="5 stelle">
                  {[...Array(5)].map((_, s) => (
                    <Star key={s} size={14} className="fill-oro text-oro" />
                  ))}
                </div>
                <blockquote className="text-nero/85 leading-relaxed text-[15px] flex-1">"{t.text}"</blockquote>
                <figcaption className="mt-6 flex items-center gap-4">
                  {t.photo ? (
                    <img src={t.photo} alt={t.name} loading="lazy"
                         className="h-12 w-12 rounded-full object-cover shrink-0 border border-oro/40" />
                  ) : (
                    <div className="h-12 w-12 rounded-full bg-bordeaux text-panna font-serif text-lg flex items-center justify-center shrink-0">
                      {t.name.split(" ").map((n) => n[0]).join("")}
                    </div>
                  )}
                  <div>
                    <p className="font-serif font-semibold text-nero">{t.name}</p>
                    <p className="text-xs uppercase tracking-wider text-oliva">{t.role}</p>
                  </div>
                </figcaption>
              </figure>
            </div>
          ))}
        </div>
      </div>
      <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-6 mt-10">
        <button data-testid="testimonial-prev" onClick={() => emblaApi?.scrollPrev()}
                className="h-11 w-11 rounded-full border border-bordeaux/30 text-bordeaux flex items-center justify-center hover:bg-bordeaux hover:text-panna transition-colors" aria-label="Precedente">
          <ChevronLeft size={18} />
        </button>
        <div className="flex gap-2">
          {testimonials.map((t, i) => (
            <span key={t.id || `dot-${t.name}-${t.role}`} className={`h-1.5 rounded-full transition-all duration-300 ${i === index ? "w-6 bg-bordeaux" : "w-1.5 bg-bordeaux/25"}`} />
          ))}
        </div>
        <button data-testid="testimonial-next" onClick={() => emblaApi?.scrollNext()}
                className="h-11 w-11 rounded-full border border-bordeaux/30 text-bordeaux flex items-center justify-center hover:bg-bordeaux hover:text-panna transition-colors" aria-label="Successiva">
          <ChevronRight size={18} />
        </button>
      </div>
    </div>
  );
}
